import React from 'react'
import styled from '@emotion/styled'
import HotIcon from '../images/Hot.svg'
import VeryHotIcon from '../images/VeryHot.svg'
import Bulb from '../images/icon-bulb-32px.svg'

const SELLING_SIGNAL = {
  HOT_PROSPECT: 'Hot Prospect',
  VERY_HOT_PROSPECT: 'Very Hot Prospect'
}

const rankingWithText = (icon, text) => () => (
  <Flex>
    <Icon src={icon} className="iconz" />
    <b>{text}</b>
  </Flex>
)
const VeryHotIconWithText = rankingWithText(VeryHotIcon, SELLING_SIGNAL.VERY_HOT_PROSPECT)
const HotIconWithText = rankingWithText(HotIcon, SELLING_SIGNAL.HOT_PROSPECT)
const BuyingSignalWithText = ({ text }) => (
  <Flex>
    <Icon src={Bulb} sizes={30} className="iconz" />
    <span>{text}</span>
  </Flex>
)

export function getFinalSellingSignalRanking(buyingSignal, sellingSignalWeight, hasBuyingSignalsSubscription) {
  if (!hasBuyingSignalsSubscription) return false

  if (sellingSignalWeight >= 0.06 && buyingSignal === 'Ready to Buy') return <VeryHotIconWithText />
  if (sellingSignalWeight >= 0.06 && sellingSignalWeight <= 0.4) {
    return <HotIconWithText />
  } else if (sellingSignalWeight > 0.4) {
    return <VeryHotIconWithText />
  }
  return false
}

export function getFinalSellingSignalRankingDashboard(buyingSignal, sellingSignal, hasBuyingSignalsSubscription) {
  if (!hasBuyingSignalsSubscription) {
    if (buyingSignal) return <BuyingSignalWithText text={buyingSignal} />
    return false
  }

  const finalSellingSignal = getFinalSellingSignalRanking(buyingSignal, sellingSignal, hasBuyingSignalsSubscription)

  if (finalSellingSignal) return finalSellingSignal
  if (buyingSignal) return <BuyingSignalWithText text={buyingSignal} />
  return false
}

const Icon = styled.img`
  margin-right: 5px;
  display: block;
  width: 12px;
`
const Flex = styled.div`
  display: flex;
`
